import { useEffect } from "react";
import "./ingresos.css";
import { useStoreIngresos } from "./useStoreIngresos";
import IngresosTab1 from "./IngresosTab11";
import IngresosTab2 from "./IngresosTab2";
import IngresosTab3 from "./IngresosTab3";
import { TabMenu } from "primereact/tabmenu";
import { MensajeError, useWindowDimensions } from "../../componentes/FuncionesLocales";
import { useStoreLogin } from "../Login/useStoreLogin";
import { useStoreHome } from "../Home/useStoreHome";
import { useNavigate } from "react-router-dom";
import BotonInstructivo from "../../ComponentesGlobales/BotonInstructivo";

const Ingresos = () => {
  const Fecha = useStoreIngresos((state) => state.Fecha);
  const TabSeleccionado = useStoreIngresos((state) => state.TabSeleccionado);
  const EsProductoTerminado = useStoreIngresos((state) => state.EsProductoTerminado);
  const FechaCaducidad = useStoreHome((state) => state.FechaCaducidad);
  const { width } = useWindowDimensions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!useStoreLogin.getState().validarVariablesGlobales()) {
      useStoreLogin.getState().logout();
    }
    useStoreIngresos.getState().getUnidades();
    useStoreIngresos.getState().getProveedores();
    useStoreIngresos.getState().getCategoriasFiscales();
    useStoreIngresos.getState().getDetalleGrillaPantalla();
  }, []);


  useEffect(() => {
    if (FechaCaducidad) {
      if (FechaCaducidad < new Date()) {
        MensajeError("La licencia de uso ha caducado. Contacte a soporte técnico.");
        navigate("/home");
      }
    }
  }, [FechaCaducidad, navigate]);


  useEffect(() => {
    useStoreIngresos.getState().getDetalleGrillaPantalla();
  }, [Fecha]);


  const items = [
    { label: 'Proce..', icon: 'pi pi-file-edit' },
    { label: EsProductoTerminado ? 'Producto terminado' : 'Materia P/Insumos', icon: 'pi pi-box' },
    { label: 'Detalles', icon: 'pi pi-list' },
  ];

  const items2 = [
    { label: 'Procedencia', icon: 'pi pi-file-edit', },
    { label: EsProductoTerminado ? 'Producto terminado' : 'Materia Prima/Insumos', icon: 'pi pi-box' }
  ];

  return (
    <div className="ingresos">

      <div className="ing-header"
        style={{
          backgroundColor: "#31576B",
          padding: "12px 16px",
          borderRadius: "8px",
          color: "#fff",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
          display: "flex",
          alignItems: "center"
        }}>

        <span className="modulo-icono" aria-hidden="true"><i className="pi pi-sign-in" /></span>
        <div >
          <h2 className="ing-titulo" style={{ color: "#f4f4f4ff", textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)" }}>Ingresos a Planta</h2>
          <p className="ing-parrafo" style={{ color: "#f4f4f4ff", textShadow: "0 2px 4px rgba(0, 0, 0, 0.2)" }}>
            Registrá materias primas, insumos y productos terminados recibidos de tus proveedores.
          </p>

        </div>

        <BotonInstructivo to="/tutorial/ingreso-planta" sobreColor className="ingresos-instructivo" />
      </div>

      <div className="ing-content-scroll">
        {width < 768 ?
          <>
            <TabMenu
              model={items}
              activeIndex={Number(TabSeleccionado)}
              onTabChange={(e) => useStoreIngresos.setState({ TabSeleccionado: e.index })}

            />

            {TabSeleccionado === 0 && (
              <div className="ing-formulario">
                <div className="ing-bloques-form">
                  <IngresosTab1 FlechaAdelante />
                </div>
              </div>
            )}

            {TabSeleccionado === 1 && (
              <div className="ing-formulario">
                <div className="ing-bloques-form">
                  <IngresosTab2 FlechaAdelante FlechaAtras />
                </div>
              </div>
            )}

            {TabSeleccionado === 2 && (
              <div className="ing-registros">
                <IngresosTab3 FlechaAtras />
              </div>
            )}

          </>
          :
          (width < 1000 ? <>
            <TabMenu model={items2} activeIndex={TabSeleccionado} onTabChange={(e) => useStoreIngresos.setState({ TabSeleccionado: e.index })} />
            <div className="ing-layout animado-entrada">
              <div className="ing-formulario">
                <div className="ing-bloques-form">

                  {TabSeleccionado === 0 && <IngresosTab1 FlechaAdelante={true} />}


                  {TabSeleccionado === 1 && <IngresosTab2 FlechaAtras={true} />}

                </div>
              </div>

              <div className="ing-registros">
                <IngresosTab3 />
              </div>

            </div>
          </>
            :
            <div className="ing-layout animado-entrada">
              <div className="ing-formulario">
                <div className="ing-bloques-form">
                  <IngresosTab1 />

                  <IngresosTab2 />
                </div>
              </div>
              <div className="ing-registros">
                <IngresosTab3 />
              </div>
            </div>
          )
        }
        
      </div>

    </div>
  );
};

export default Ingresos;
